/**
 * Hand-off of a finished generation to the YouTube publish form.
 *
 * ResultDisplay lives on a different page than the form, which is not mounted
 * (and, on desktop, is on a different sub-tab) when the user clicks "Publish".
 * A fire-and-forget window event is lost in that case, so the preset is parked
 * here until the form mounts or, when it is already mounted, is notified.
 */

import type { YouTubePublishPreset } from './types';

let pending: YouTubePublishPreset | null = null;
const listeners = new Set<() => void>();

export function setPendingPublishPreset(preset: YouTubePublishPreset): void {
  pending = preset;
  listeners.forEach((listener) => listener());
}

export function peekPendingPublishPreset(): YouTubePublishPreset | null {
  return pending;
}

export function clearPendingPublishPreset(): void {
  pending = null;
}

export function subscribePendingPublishPreset(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
